<template>
    <div>
        <menu-bar/>

        <div class="container" role="main">
            <div class="row" style="margin-top: 50px">

                <ol class="breadcrumb">
                    <li><a href="#/"> <i class="fa fa-home" aria-hidden="true"></i>INICIAL</a></li>
                    <li class="active"><i class="fa fa-id-card-o" aria-hidden="true"></i> CLIENTES</li>
                </ol>

                <div class="row">
                    <div class="col-md-3">
                        <menu-cliente/>
                    </div>
                    <div class="col-md-9">

                        <div class="col-md-7">
                            <label class="control-label">BUSCA POR NOME DO CLIENTE</label>
                            <input type="text" v-model="nome" class="form-control">
                        </div>

                        <div class="col-md-5">
                            <br/>
                            <blockquote class="blockquote-reverse">
                                Total de Clientes: <b>{{ getContratos.length }}</b>
                            </blockquote>
                        </div>

                        <div class="col-md-12" style="margin-top: 20px">

                            <table id="mytable" class="table table-bordred table-striped">

                                <thead>
                                <tr>
                                    <th>CLIENTE</th>
                                    <th style="text-align: center;width: 180px">AÇÕES</th>
                                </tr>
                                </thead>

                                <tbody>

                                <tr v-for="r in getContratos" v-bind:key="r._id">
                                    <td style="vertical-align: middle; text-transform: uppercase">{{ r.nome }}</td>
                                    <td style="text-align: center">
                                        <a :href="'#/cliente/' + r._id" class="btn btn-primary btn-xs">
                                            ABRIR <i class="fa fa-angle-double-right" aria-hidden="true"></i>
                                        </a>
                                        &nbsp;
                                        <div class="btn-group" v-if="user.level < 3">
                                            <a href="#" class="btn btn-success btn-xs">AÇÕES</a>
                                            <a href="#" class="btn btn-success dropdown-toggle btn-xs"
                                               data-toggle="dropdown"><span class="caret"></span></a>
                                            <ul class="dropdown-menu">
                                                <li v-if="!user.permissoes.cacontrol">
                                                    <a :href="'#/contrato/novo/' + r._id">
                                                        <i class="fa fa-plus" aria-hidden="true"></i> NOVO CONTRATO
                                                    </a>
                                                </li>
                                                <li class="divider" v-if="!user.permissoes.cacontrol"></li>
                                                <li v-if="user.level === 1 && !user.permissoes.cacontrol">
                                                    <a href="#">
                                                        <i class="fa fa-trash" aria-hidden="true"></i> EXCLUIR O CLIENTE
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </td>
                                </tr>

                                </tbody>

                            </table>

                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import MenuCliente from "../../menus/clientes.vue";
import { Cliente } from "../../class/clientes";

export default {
    components: {
        MenuCliente
    },
    data() {
        return {
            contratos: [],
            user: null,
            nome: null
        };
    },
    computed: {
        getContratos: function() {
            if (!this.nome) {
                return this.contratos;
            }

            return this.contratos.filter(player => {
                return player.nome
                    .toLowerCase()
                    .includes(this.nome.toLowerCase());
            });
        }
    },
    beforeMount() {
        this.user = this.$store.state.user;

        Cliente.all()
            .then(rows => (this.contratos = rows))
            .catch(err => console.log(err));
    }
};
</script>
